import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutMyNewPackageComponent } from './my-new-package.component';

import { InfoMessageModule } from 'src/app/shared/components/info-message/info-message.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { PackageModule } from '../../shared/components/package/package.module';
import { PackageHelperModule } from '../../shared/components/package-helper/package-helper.module';


import { ToggleModule } from 'src/app/shared/components/toggle/toggle.module';
import { ProductModule } from "../../shared/components/product/product.module";
import { packageSuggestionModalDisplayLogService } from 'src/app/shared/services/packageSuggestionModalDisplayLog.service';
import { OneClickPurchaseModule } from 'src/app/shared/components/one-click-purchase/one-click-purchase.module';
import { ProductConsultaModule } from 'src/app/shared/components/product-consulta/product-consulta.module';
import { ConsultaShopWindowModule } from '../shop-windows/consulta-shop-window/consulta-shop-window.module';
import { RecargaPontualShopWindowModule } from '../shop-windows/recarga-pontual-shop-window/recarga-pontual-shop-window.module';
import { ConsultaCampaignShopWindowModule } from "../shop-windows/consulta-campaign-shop-window/consulta-campaign-shop-window.module";

@NgModule({
  imports: [
    CommonModule,
    InfoMessageModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    PackageModule,
    PackageHelperModule,
    
    ProductModule,
    OneClickPurchaseModule,
    ToggleModule,
    ProductModule,
    ProductConsultaModule,
    ConsultaShopWindowModule,
    RecargaPontualShopWindowModule,
    ConsultaCampaignShopWindowModule
  ],
  exports: [
    CheckoutMyNewPackageComponent
  ],
  providers: [
    packageSuggestionModalDisplayLogService
  ],
  declarations: [
    CheckoutMyNewPackageComponent
  ]
})
export class CheckoutMyNewPackageModule { }
